var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EmptyStatus',{attrs:{"type":_vm.option.type,"marginTop":_vm.option.marginTop,"showBackButton":_vm.option.showBackButton,"message":_vm.option.message},on:{"onReload":_vm.refreshPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }